export default function PictureBean() {
    this.picId = -1
    this.picName = ''
    this.picUrl = ''
    this.picDate = ''
    this.picType = 1
    this.picStatus = 2
    this.parentId = -1
    this.picRemarks = ''
    this.schId = -1
    this.quantity = -1
    this.schName = ''

    this.uid = -1
    this.url = ''
    this.type = ''
    this.thumbUrl = ''
    this.status = ''
    this.size = ''
    this.response = ''
}